module.exports = __webpack_public_path__ + "img/scheme-btn.72177653.gif";